<template>
  <div class="profile">
    <template v-if="$route.name === 'profile'">
      <!--用户头部-->
      <div class="profile-header">
        <div class="profile-avatar">
          <img :src="user.avatar" alt="">
        </div>
        <div class="profile-user">
          <b class="profile-name">{{user.nickname}}</b>
          <div class="profile-email" v-if="user.email">{{user.email}}</div>
        </div>
        <button class="profile-logout-btn" @click="logoutConfirm">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          {{$tc('profile.itemLogout', 1)}}
        </button>
      </div>
      <!--菜单列表-->
      <div class="profile-menu">
        <router-link :to="{name: 'shelf'}" class="profile-menu__item">
          <div class="profile-menu__icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>
          </div>
          <span>{{$t('profile.itemShelf')}}</span>
          <svg class="profile-menu__arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </router-link>
        <router-link :to="{name: 'order-list'}" class="profile-menu__item">
          <div class="profile-menu__icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </div>
          <span>{{$t('profile.itemOrder')}}</span>
          <svg class="profile-menu__arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </router-link>
        <router-link :to="{name: 'profile-invitation'}" class="profile-menu__item">
          <div class="profile-menu__icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>
          </div>
          <span>{{$t('profile.itemInvitation')}}</span>
          <span class="profile-menu__tag">Hot</span>
          <svg class="profile-menu__arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </router-link>
        <router-link :to="{name: 'profile-coupons'}" class="profile-menu__item">
          <div class="profile-menu__icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20 12V8H6a2 2 0 01-2-2c0-1.1.9-2 2-2h12v4"/><path d="M4 6v12c0 1.1.9 2 2 2h14v-4"/><path d="M18 12a2 2 0 000 4h4v-4z"/></svg>
          </div>
          <span>{{$t('profile.itemCoupons')}}</span>
          <svg class="profile-menu__arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </router-link>
        <router-link :to="{name: 'group-start'}" class="profile-menu__item">
          <div class="profile-menu__icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
          </div>
          <span>{{$t('profile.itemGroup')}}</span>
          <svg class="profile-menu__arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </router-link>
      </div>
      <a href="/app/shelf" class="profile-back-old" @click="rememberOldVersion">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        {{$t('profile.backToOld')}}
      </a>
    </template>
    <router-view></router-view>
  </div>
</template>

<script>
import api from 'src/api/'
import { mapActions, mapGetters } from 'vuex'
import Cookies from 'js-cookie'

export default {
  name: '',
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'user', 'language'
    ])
  },
  mounted () {
    this.fetchUserInfo()
  },
  beforeRouteLeave (to, from, next) {
    this.setLoading(false)
    next()
  },
  methods: {
    ...mapActions([
      'setLoading', 'setUser'
    ]),
    rememberOldVersion () {
      // 7 天内访问域名根路径默认进旧版（nginx 按此 cookie 分流），到期自动回新版
      // domain 设 .ipastbook.com 让 m.ipastbook.com 也能读到
      Cookies.set('prefer_v1', '1', { expires: 7, path: '/', domain: '.ipastbook.com' })
    },
    logoutConfirm () {
      this.$confirm({
        title: this.$t('profile.tipLogout'),
        okText: this.$t('button.ok'),
        cancelText: this.$t('button.cancel'),
        okClass: 'text-primary',
        cancelClass: 'text-gray',
        onOk: modal => {
          this.setUser({})
          Cookies.remove('m_user')
          window.location.href = '/'
          modal.close()
        }
      })
    },
    fetchUserInfo () {
      return api.fetchUser(this.user.uid).then(data => {
        if (data.errors) {
          return
        }
        this.setUser(data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.profile {
  max-width: 640px;
  margin: 0 auto;
  padding: 2rem 1rem;

  @media (min-width: 560px) {
    margin-top: 60px;
  }
}

.profile-header {
  display: flex;
  align-items: center;
  padding: 24px 0;
  margin-bottom: 8px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 20px;

  .profile-avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background-color: #f3f4f6;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .profile-user {
    flex: 1;
    margin-left: 16px;
    min-width: 0;
  }

  .profile-name {
    font-size: 18px;
    font-weight: 600;
    display: block;
  }

  .profile-email {
    font-size: 13px;
    color: #9ca3af;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .profile-logout-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #9ca3af;
    background: none;
    border: none;
    cursor: pointer;
    padding: 6px 12px;
    border-radius: 8px;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover {
      color: #ef4444;
      background: #fef2f2;
    }
  }
}

.profile-menu {
  display: flex;
  flex-direction: column;

  &__item {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    border-radius: 12px;
    color: #374151;
    font-size: 15px;
    font-weight: 500;
    transition: all 0.2s;
    text-decoration: none;
    border: 1px solid transparent;

    &:hover {
      background-color: white;
      border-color: #e5e7eb;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    }

    > span:first-of-type {
      flex: 1;
    }
  }

  &__icon {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #f3f4f6;
    margin-right: 14px;
    color: $el-color-primary;
    flex-shrink: 0;
  }

  &__arrow {
    color: #d1d5db;
    flex-shrink: 0;
  }

  &__tag {
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    background: $el-color-primary;
    color: white;
    padding: 2px 8px;
    border-radius: 100px;
    margin-right: 8px;
    flex-shrink: 0;
    flex-grow: 0;
  }

  &__item + &__item {
    margin-top: 2px;
  }
}

.profile-back-old {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 24px 16px 0;
  padding: 14px 32px;
  border: 1px solid $el-color-primary;
  border-radius: 10px;
  color: $el-color-primary;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  background: #fff;
  transition: all 0.2s;

  &:hover {
    background: rgba(245, 99, 104, 0.06);
  }
}
</style>
